import { grey } from "@material-ui/core/colors";

const muiOverrides = {
  MuiPaper: {
    root: {
      backgroundColor: grey[50],
      boxShadow: `0px 2px 5px ${grey[400]} !important`,
    },
  },
  MuiGrid: {
    item: {
      height: "inherit",
    },
  },
  MuiDrawer: {
    root: {
      backgroundColor: grey[800],
      paddingTop: 8,
    },
  },
  MuiTableSortLabel: {
    active: {
      color: grey[700],
    },
    icon: {
      color: grey[700],
    },
  },
};

export default muiOverrides;
